import Header from "./Header";
import { PrintClient, ScenarioSettings } from "src/types";
import CompositeTable from "./CompositeTable";

const Composite = ({
  scenario,
  client,
}: {
  scenario: ScenarioSettings;
  client: PrintClient;
}) => {
  return (
    <div className="mx-5 flex justify-center flex-col">
      <Header client={client} scenario={scenario} page="Composite" />
      <CompositeTable scenario={scenario} client={client} print />
    </div>
  );
};

export default Composite;
